import { call, put, select, takeLatest } from "redux-saga/effects";

import { FundSelector } from "redux/selector/fund-selector";
import { FundAPI } from "services/fund";
import { 
  searchFund, searchFundFailure, searchFundSuccess,
  getFundDetail, getFundDetailSuccess, getFundDetailFailure , getNavDetailList, getNavDetailListSuccess, getNavDetailListFailure } from "redux/reducers/fund";
import { toPagingServer } from "utils/common-util";

function* searchFundSaga({ payload = {}}) {
  try {
    const { isLoadMore = false, extend, fundName, fundSubTypeList, fundIssuerList, fundDividend, recommend } = payload
    const paginable = yield select(FundSelector.paginable)
    const nextPage = isLoadMore
      ? { ...paginable, current: paginable.current + 1 }
      : paginable

      let fundSubTypeSelect = [];
      let fundIssuerSelect = [];

      if(fundSubTypeList){
        fundSubTypeList.map((fundSubType) => (
          fundSubTypeSelect.push(fundSubType.code)
        ));
      }
     
      if(fundIssuerList){
        fundIssuerList.map((issuer) => (
          fundIssuerSelect.push(issuer.fundIssuerId)
        ));
      }

    const params = {
      ...toPagingServer(nextPage),
      fundName, 
      fundSubTypeList : fundSubTypeSelect, 
      fundIssuerList : fundIssuerSelect, 
      fundDividendList : fundDividend,
      recommend,
    }
    const response = yield call(FundAPI.searchFund, params);
    let fundList = response.data.fundSearchList ?? [],
      total = response.data.total
  
    if (extend) {
      const fetcheFunds = yield select(FundSelector.fundList);
      fundList = [...fetcheFunds, ...fundList]
    }
    yield put(searchFundSuccess({ fundList, total, paginable: nextPage }));
  } catch (error) {
    console.error(error)
    yield put(searchFundFailure(error));
  } finally {
    if (payload.unblockLoadMore) payload.unblockLoadMore()
  }
}

function* getFundDetailSaga(action) {
  try {
    const response = yield call(FundAPI.getFundDetail, action.payload);
    yield put(getFundDetailSuccess({
      fundDetail: response.data.fundDetail
    }));
  } catch (error) {
    yield put(getFundDetailFailure(error));
  }
}

function* getNavDetailListSaga(action) {
  try {
    const response = yield call(FundAPI.getNavDetailList, action.payload);
    yield put(getNavDetailListSuccess({
      navDetailList: response.data.navDetailList
    }));
  } catch (error) {
    yield put(getNavDetailListFailure(error));
  }
}


const saga = [
  takeLatest(searchFund.type, searchFundSaga),
  takeLatest(getFundDetail.type, getFundDetailSaga),
  takeLatest(getNavDetailList.type, getNavDetailListSaga),
];

export default saga;
